define([
    './NavigationService',
    './NavigationDirective',
    './NavigationListener',
    './SwipeDirective',
    'angularRouter'
], (NavigationHistoryService, NavigationDirective, NavigationListener, swipeDirective)=> {
    return angular.module('edge.platform.navigation', ['ui.router'])
        .factory('NavigationService', NavigationHistoryService)
        .directive('gwPlNavigation', NavigationDirective)
        .directive('gwSwipeLeft', swipeDirective('gwSwipeLeft', -1))
        .directive('gwSwipeRight', swipeDirective('gwSwipeRight', 1))
        .run(NavigationListener);
});



// WEBPACK FOOTER //
// ../common/js/src/edge/platform/navigation/module.js